(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["script-landing-hero"] && !Shopify.designMode) return;
  try {
    /* ============================================================
     landing-hero — logo intro and early-access blinker (GSAP)
     [data-logo-animate]  svg whose letters slide in from the left, each
                          clipped to its own box, staggered left to right.
                          Every letter travels the widest letter's width,
                          so narrow letters surface last
     [data-logo-letter]   one path per letter
     [data-blinker]       dot that pulses between 30% and full opacity
     ============================================================ */
  (() => {
    const SVG_NS = 'http://www.w3.org/2000/svg';
    let clipCount = 0;
    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initLogo(logo) {
      if (logo.hasAttribute('data-logo-animate-init')) return;
      logo.setAttribute('data-logo-animate-init', '');

      if (!window.gsap || prefersReducedMotion()) {
        logo.classList.remove('is-pending');
        return;
      }

      const letters = [...logo.querySelectorAll('[data-logo-letter]')];
      const height = logo.viewBox.baseVal.height;
      const defs = document.createElementNS(SVG_NS, 'defs');
      const groups = [];
      logo.prepend(defs);

      const boxes = letters.map((letter) => letter.getBBox());
      const distance = Math.max(...boxes.map((box) => box.width));

      letters.forEach((letter, index) => {
        const box = boxes[index];
        const id = `logo-clip-${clipCount++}`;

        const clip = document.createElementNS(SVG_NS, 'clipPath');
        clip.id = id;
        const rect = document.createElementNS(SVG_NS, 'rect');
        rect.setAttribute('x', box.x);
        rect.setAttribute('y', 0);
        rect.setAttribute('width', box.width);
        rect.setAttribute('height', height);
        clip.append(rect);
        defs.append(clip);

        const group = document.createElementNS(SVG_NS, 'g');
        group.setAttribute('clip-path', `url(#${id})`);
        letter.before(group);
        group.append(letter);
        groups.push(group);
      });

      gsap.set(letters, { x: -distance });

      logo.classList.remove('is-pending');

      const timeline = gsap.timeline({
        delay: 0.25,
        onComplete: () => {
          for (const group of groups) group.removeAttribute('clip-path');
          defs.remove();
        },
      });

      letters.forEach((letter, index) => {
        timeline.to(letter, { x: 0, duration: 0.32 + index * 0.055, ease: 'expo.out' }, index * 0.02);
      });
    }

    function initBlinker(blinker) {
      if (blinker.hasAttribute('data-blinker-init') || !window.gsap || prefersReducedMotion()) return;
      blinker.setAttribute('data-blinker-init', '');

      gsap.fromTo(blinker, { opacity: 1 }, { opacity: 0.3, duration: 0.6, ease: 'sine.inOut', repeat: -1, yoyo: true });
    }

    function init() {
      if (!window.gsap && document.readyState !== 'complete') {
        window.addEventListener('load', init, { once: true });
        return;
      }
      for (const logo of document.querySelectorAll('[data-logo-animate]')) initLogo(logo);
      for (const blinker of document.querySelectorAll('[data-blinker]')) initBlinker(blinker);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
